import React, { useState } from "react";
import { CloseOutlined } from "@ant-design/icons";
import "./styles/input.css";

const renderInput = (type, placeholder = "Default title", helper = "", required = false,
  value, setValue, focused, setFocused, touched, setTouched) => {
  const id = `input-${placeholder.replace(/\s+/g, "-").toLowerCase()}`;

  const isEmpty = String(value).trim() === "";
  const hasError = required && isEmpty && (focused || touched);

  const hours = Math.floor(value / 60);
  const minutes = value % 60;

  const handleHoursChange = (e) => {
    const newHours = parseInt(e.target.value) || 0;
    setValue(newHours * 60 + minutes);
  };

  const handleMinutesChange = (e) => {
    const newMinutes = parseInt(e.target.value) || 0;
    setValue(hours * 60 + newMinutes);
  };

  const groupClass = [
    "inputContainer",
    required ? "is-required" : "",
    focused ? "is-focused" : "",
    isEmpty ? "is-empty" : "is-filled",
    touched ? "is-touched" : "",
    hasError ? "has-error" : "",
    type === "time" ? "is-time" : "" 
  ].join(" ").trim();

  if (type !== "duration"){
    return (
      <div className={groupClass}>
        <input id={id} type={type || "text"} value={value} placeholder={placeholder? placeholder : " "}
          onChange={(e) => {
            setValue(e.target.value);
          }}
          onFocus={() => setFocused(true)}
          onBlur={() => {
            setFocused(false);
            setTouched(true);
          }}
        />
        {!isEmpty && type !== "date" && type !== "time" ? 
          <button onClick={()=> setValue("")}>
            <CloseOutlined/>
          </button>
          : null  }
        <label className="label" htmlFor={id}>
          {placeholder}
          {required && <span aria-hidden="true" style={{color: "red"}}>&nbsp;*</span>}
        </label>
        {helper ? (
          <span className="helper" role={hasError ? "alert" : undefined}>
            {helper}
          </span>
        ) : null}
      </div>
    )
  }
  
  return (
    <div className="durationContainer">
      <input
        type="number"
        min="0"
        max="12"
        placeholder="0"
        value={hours}
        onChange={handleHoursChange}
      />
      <span>h</span>
      <input
        type="number"
        min="0"
        max="59"
        placeholder="0"
        value={minutes}
        onChange={handleMinutesChange}
      />
      <span>m</span>
      <label className="label" htmlFor={id}>
          {placeholder}
          {<span aria-hidden="true" style={{color: "red"}}>&nbsp;*</span>}
      </label>
    </div>
  );
};


const Input = ({ type, placeholder, helper, required = false, value, setValue }) => {
  const [focused, setFocused] = useState(false);
  const [touched, setTouched] = useState(false);
  return (
    (typeof value === 'undefined' || typeof setValue === 'undefined') ? console.error("At least one of the required parameters value or setValue props are missing in the Input component. Add them to use the Input. (See React hook useState for setters).") 
      : renderInput(type, placeholder, helper, required, value,
    setValue, focused, setFocused, touched, setTouched)); 
};

export default Input;